// extracted by mini-css-extract-plugin
export default {"container":"container-txZ38","headingWrapper":"headingWrapper-eGOXM","heading":"heading-hxQj4","icon":"icon-XXEYI"};